import {
  Input,
  FormGroup,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "design-react-kit";
import { useEffect, useState } from "react";

const ModalComponent = (props) => {
  const handleToggle = () => {
    // Chiudo il modal
    props.toggleModal(!props.isOpen);

    // Se è stato passato onClose e il modal stava per essere chiuso, lo chiamo
    if (props.onClose && props.isOpen) {
      props.onClose();
    }
  };
  return (
    <div>
      <Modal
        isOpen={props.isOpen}
        toggle={handleToggle}
        size={props.size ? props.size : "lg"}
        labelledBy={props.labelledBy}
      >
        <ModalHeader style={{ fontSize: "1.1rem" }} id={props.labelledBy}>
          {props.header}
        </ModalHeader>
        <ModalBody>{props.body}</ModalBody>
        <ModalFooter>
          {props.buttonConfirm && (
            <Button
              color="btn btn-outline-primary border"
              onClick={() => props.function()}
              disabled={props.buttonConfirmDisabled}
              title={
                props.buttonConfirmDisabled
                  ? "Azione non consentita"
                  : props.buttonConfirm
              }
            >
              {props.buttonConfirm}
            </Button>
          )}
          {props.buttonDeny && (
            <Button
              color="btn btn-secondary"
              onClick={() => (props.toggleModal(!props.isOpen), handleToggle())}
            >
              {props.buttonDeny}
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </div>
  );
};
export default ModalComponent;
